import { Row, Col } from "antd";
import React, { Component } from "react";
import DashboardStatsCard from "../../components/DashboardStatsCard";
import { Deleted, Approved, Pending, Orders } from "../../config/images";
import PlantOrder from "../../components/DashboardStatsCard/plantorder";
import { connect } from "react-redux";
import { DashboardAction, UserAction } from "../../store/actions";
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        column: "name",
        status: "pending",
        search: "",
        totalCount: 0,
        currentCount: 0,
        total_pages: 0,
        start_date: "",
        end_date: "",
        period: "",
      },
    };
  }
  componentDidMount() {
    const { getCounts, getOrders, getUserDetails } = this.props;

    const companyId = this.props.user?.[1]?.rmx_company?.id;
    const userId = this.props.user?.[2]?.rmx_company_user?.id;
    if (companyId) {
      getCounts(companyId);
      getOrders(companyId, this.state.filter);
      getUserDetails(userId);
    }
  }
  componentDidUpdate(preProps, preState) {
    const { getCounts, getOrders, getUserDetails } = this.props;
    const id = this.props?.user?.[1]?.rmx_company?.id;
    const userId = this.props?.user?.[2]?.rmx_company_user?.id;
    if (preProps.user[0] !== this.props.user[0]) {
      getCounts(id);
      getOrders(id, this.state.filter);
      getUserDetails(userId);
    }

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }
    if (
      preState.filter.page !== this.state.filter.page ||
      preState.filter.search !== this.state.filter.search ||
      preState.filter.status !== this.state.filter.status ||
      preState.filter.start_date !== this.state.filter.start_date ||
      preState.filter.end_date !== this.state.filter.end_date ||
      preState.filter.period !== this.state.filter.period
    ) {
      getOrders(id, this.state.filter);
    }
  }
  onChangeTab = (key) => {
    const { getOrders } = this.props;

    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    if (key == "1") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "pending",
        },
      });
      getOrders(companyId, { ...this.state.filter, status: "pending" });
    }
    if (key == "2") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "approved",
        },
      });
      getOrders(companyId, { ...this.state.filter, status: "approved" });
    }
    if (key == "3") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "dispatched",
        },
      });
      getOrders(companyId, { ...this.state.filter, status: "dispatched" });
    }
    if (key == "4") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "rejected",
        },
      });
      getOrders(companyId, { ...this.state.filter, status: "rejected" });
    }
    if (key == "5") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "completed",
        },
      });
      getOrders(companyId, { ...this.state.filter, status: "completed" });
    }
  };
  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };
  onChangeText = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: e.target.value,
      },
    });
  };
  onChangeFilter = (end_date, start_date) => {
    this.setState({
      filter: {
        ...this.state.filter,
        start_date,
        end_date,
      },
    });
  };
  onChangePeriod = (period) => {
    this.setState({
      filter: {
        ...this.state.filter,
        period,
      },
    });
  };
  render() {
    const { counts, loading } = this.props;

    return (
      <Row justify="space-between">
        <Col xl={4} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Pending}
            inputText={"PENDING ORDERS"}
            value={counts.pending}
            loading={loading}
          />
        </Col>
        <Col xl={4} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Approved}
            inputText={"APPROVED ORDERS"}
            value={counts.approved}
            loading={loading}
          />
        </Col>
        <Col xl={4} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Orders}
            inputText={"DISPATCHED ORDERS"}
            value={counts.dispatched}
            loading={loading}
          />
        </Col>
        <Col xl={4} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Deleted}
            inputText={"REJECTED ORDERS"}
            value={counts.rejected}
            loading={loading}
          />
        </Col>
        <Col xl={4} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Approved}
            inputText={"COMPLETED ORDERS"}
            value={counts.completed}
            loading={loading}
          />
        </Col>
        <Col xl={24} lg={24} sm={24} xs={24} md={24}>
          <PlantOrder
            {...this.props}
            onChangeTab={this.onChangeTab}
            metaData={this.state.filter}
            currentPage={this.currentPage}
            previousPage={this.previousPage}
            onChangeText={this.onChangeText}
            onChangeFilter={this.onChangeFilter}
            onChangePeriod={this.onChangePeriod}
          />
        </Col>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    counts: store.DashboardReducer.orderCount,
    Orders: store.DashboardReducer.orders,
    user: store.AuthReducer.user,
    metaData: store.DashboardReducer.metaData,
    loading: store.DashboardReducer.isLodadingCount,
    isLoader: store.DashboardReducer.isOrder,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getCounts: (id) => dispatch(DashboardAction.getCountReq(id)),
    getOrders: (id, params) =>
      dispatch(DashboardAction.getOrderReq(id, params)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
